// extracted by mini-css-extract-plugin
export default {"TenancyBlock__highlight":"TenancyBlock_TenancyBlock__highlight__rxz1A","Header":"TenancyBlock_Header__NcydS","Body":"TenancyBlock_Body__pgTj1","Row":"TenancyBlock_Row__PP4No"};